/**
 * * @module component/related-articles.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Bootstrap from "bootstrap";
import owlCarousel from "owl.carousel";

const RelatedArticles = Backbone.View.extend({
  initialize: function () {
    this.render();
  },

  relatedArticlesCarousel: function () {
    const windowWidth = $(window).width();
    const $carouselContainer = $(".related-articles-carousel");
    // const isEvents = $carouselContainer.parent().hasClass("events");
    let itemsOnSmallDesktop = 3;
    const isTwoColView = $carouselContainer.parents().hasClass("article-grid");
    if ($carouselContainer.length == 0){
      return;
    }    
    // if (isEvents){
    //   itemsOnSmallDesktop = 2;
    // }

    const owl = $(".related-articles-carousel"),
      owlOptions = {
        loop: false,
        touchDrag: true,
        items: 1,
        margin: 16,
        dots: false,
        nav: true,
        // responsiveClass: true,
        navText: [
          "<span class='icon icon-arrow-left'></span>",
          "<span class='icon icon-arrow-right'></span>",
        ],
        responsive: isTwoColView ? {
          768: {
            items: 2,
            margin: 20,
            dots: true,
          }
        } : {
          768: {
            items: 2,
            margin: 20,
            dots: true,
          },
          1024: {
            items: itemsOnSmallDesktop,
            margin: 20,
            dots: true,
          },
          1280: {
            items: 3,
            margin: 20,
            dots: true,
          },
        },
      };

    const owlActive = owl.owlCarousel(owlOptions);

    if (windowWidth >= 768 ) {
      const $nav = $(".related-articles-carousel .owl-nav");
      const parentsPosition = $(
        ".related-articles-carousel"
      )[0].getBoundingClientRect();
      const positionLeft = parentsPosition.left;

      $nav.css("left", "-" + positionLeft + 'px');

      $nav.width(windowWidth);
    }

    // if (windowWidth <= 414) {
    //   console.log($carouselContainer.parent().hasClass("events"));
    //   if ($carouselContainer.parent().hasClass("events")) {
    //     $(".related-articles-container.events .related-item")
    //       .width(windowWidth)
    //       .addClass("resized");
    //   }
    // }
  },

  render: function () {
    this.relatedArticlesCarousel();
  },
});

export default RelatedArticles;
